import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Card, Row, Col, Typography, Divider } from 'antd';
import {
  FilePdfOutlined
} from '@ant-design/icons';
import {
  GET_JURIDICAL_CERT
} from '../../state/assets/types';
import { RESOURCE } from '../../config/constants/alerts';
import PropTypes from 'prop-types';

const { Title } = Typography;

const ShowCertificate = ({ getCert, contract }) => {

  const [lessorHasLegalPerson, setLessorHasLegalPerson] = useState(false);
  const [lesseeHasLegalPerson, setLesseeHasLegalPerson] = useState(false);
  const [codebtorHasLegalPerson, setCodebtorHasLegalPerson] = useState(false);

  useEffect(() => {
    if (contract.arrendador.personaJuridica) {
      setLessorHasLegalPerson(true);
    }
    if (contract.arrendatario.personaJuridica) {
      setLesseeHasLegalPerson(true);
    }
    if (contract.arrendatarios && contract.arrendatarios[0]) {
      contract.arrendatarios.map(lessee => lessee.personaJuridica && setLesseeHasLegalPerson(true));
    }
    if (contract.codeudor && contract.codeudor.personaJuridica) {
      setCodebtorHasLegalPerson(true);
    }
    if (contract.codeudores && contract.codeudores[0]) {
      contract.codeudores.map(codebtor => codebtor.personaJuridica && setCodebtorHasLegalPerson(true));
    }
  }, [contract]);

  const PdfButton = (params) => (
    <FilePdfOutlined
      style={{ fontSize: '60px' }}
      onClick={() => getCert(params.id)}
    />
  );

  const DownloadFragment = ({ signer }) => {
    return (
      <Col span={24} className="mb-2">
        <p><b>Certificado persona jurídica {signer.nombre} {signer.apellido}</b></p>
        <PdfButton id={signer.personaJuridica.certificadoPoder} />
        <p>descargar</p>
      </Col>
    );
  };

  return (
    <Card>
      <Row className="justify-content-center">
        <Col span={24}>
          <Title level={3}>Certificados personas jurídicas</Title>
        </Col>
      </Row>
      {lessorHasLegalPerson &&
        <React.Fragment>
          <Row gutter={16} >
            <Col span={24}>
              <Title level={4}>Arrendador</Title>
            </Col>
            {contract.arrendador.personaJuridica && (
              <DownloadFragment
                signer={contract.arrendador}
              />
            )}
          </Row>
          <Divider />
        </React.Fragment>
      }
      {lesseeHasLegalPerson &&
        <React.Fragment>
          <Row gutter={16} >
            <Col span={24}>
              <Title level={4}>Arrendatario</Title>
            </Col>
            {contract.arrendatario.personaJuridica && (
              <DownloadFragment
                title='Arrendatario'
                signer={contract.arrendatario}
              />
            )}
          </Row>
          <Row gutter={16} >
            {contract.arrendatarios && contract.arrendatarios[0] && (
              contract.arrendatarios.map(signer => (
                signer.personaJuridica && (
                  <DownloadFragment
                    title='Arrendatario'
                    signer={signer}
                  />
                )
              ))
            )}
          </Row>
          <Divider />
        </React.Fragment>
      }
      {codebtorHasLegalPerson &&
        <React.Fragment>
          <Row gutter={16} >
            <Col span={24}>
              <Title level={4}>Codeudor</Title>
            </Col>
            {contract.codeudor && contract.codeudor.personaJuridica && (
              <DownloadFragment
                title='Codeudor'
                signer={contract.codeudor}
              />
            )}
          </Row>
          <Row gutter={16} >
            {contract.codeudores && contract.codeudores[0] && (
              contract.codeudores.map(signer => (
                signer.personaJuridica && (
                  <DownloadFragment
                    title='Codeudor'
                    signer={signer}
                  />
                )
              ))
            )}
          </Row>
        </React.Fragment>
      }
      {!lessorHasLegalPerson && !lesseeHasLegalPerson && !codebtorHasLegalPerson &&
        <Col span={24}>
          <p><b>Contrato sin personas jurídicas</b></p>
        </Col>
      }
    </Card >
  );
};

ShowCertificate.propTypes = {
  getCert: PropTypes.func.isRequired,
  contract: PropTypes.object.isRequired,
  signer: PropTypes.object,
};

const data = (state) => ({
  contract: state.contract.contract,
});

const action = (dispatch) => ({
  getCert: (id) => dispatch({ type: GET_JURIDICAL_CERT, payload: { id, resource: RESOURCE.GET_JURIDICAL_CERT } }),
});

export default connect(data, action)(ShowCertificate);